import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { environment } from '../../../environments/environment';
import { FormObjectComponent } from '../../../shared/forms/form-object.component';
import { ReferenceCache } from '../../reference/services/reference.cache';
import { PartComponent } from '../../reference/models/part-component';
import { ComponentOptions } from '../models/component-option';
import { ClaimsAppSubmissionConstant } from '../models/claims-app-submission.constant';
import { CorrectionEstimateListComponent } from '../estimates/correction-estimate-list/correction-estimate-list.component';

@Component({
  selector: 'claims-app-concern-cause-part',
  templateUrl: './claims-app-concern-cause-part.component.html',
  styleUrls: ['./claims-app-concern-cause-part.component.scss']
})
export class ClaimsAppConcernCausePartComponent extends FormObjectComponent implements OnInit, OnDestroy {
  @Input() partComponent: PartComponent;
  @ViewChild(CorrectionEstimateListComponent) correctionEstimateList: CorrectionEstimateListComponent;
  /**
   * A subject that can be used to automatically end subscriptions when the component is destroyed.
   * @private
  */
  private readonly _destroying$ = new Subject<void>();
 
  public override form: UntypedFormGroup;

    public enableEstimateUi: boolean = environment.enableEstimateUi == "true";

  public get isLoading(): boolean {
    return this.referenceCache.updatingComponents;
  }

  public get isCustomComponent(): boolean {
    if (!this.form.get('component')) {
      return false;
    }

    return this.form.get('component').disabled
           && (this.form.getRawValue()['component']?.groupName === ClaimsAppSubmissionConstant.createNewComponentLabel);
  }

  constructor(private referenceCache: ReferenceCache) {
    super();
  }

  ngOnInit(): void {
    this.form = new UntypedFormGroup({
      'concern': new UntypedFormControl("", [Validators.required]),
      'cause': new UntypedFormControl("", [Validators.required]),
      'componentGroup': new UntypedFormControl({ value: "", disabled: true }),
    });
  }
  
  ngOnDestroy(): void {    
		this._destroying$.next(undefined);
		this._destroying$.complete();
  }

  public onSelectedComponent(componentOptions: ComponentOptions): void {
    // If this is a custom part (not from the predefined list)
    if (componentOptions?.groupName == ClaimsAppSubmissionConstant.createNewComponentLabel) {
      this.form.get("componentGroup").setValue("None");
    }
    else {
      this.form.get("componentGroup").setValue(componentOptions?.groupName);
    }

    this.partComponent = new PartComponent(componentOptions?.name,
                                           componentOptions?.groupName,
                                           componentOptions?.code);
  }

  public override validateForm(): void {
    super.validateForm();

    // If the form is valid so far, check the correction list.
    if (this.formCompleted && this.correctionEstimateList) {
      this.correctionEstimateList.validateForm();
      this.formCompleted = this.correctionEstimateList.formCompleted;
    }
  }
}
